// ------
// Basic selectors
export const selectGrinders = state => {
  return state.qualityGrinders.data;
};
